import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const technologies = [
  {
    category: "Backend & AI",
    items: [
      "Python (Streamlit, FastAPI, Scrapy)",
      "Node.js, Express.js",
      "OpenAI (GPT models, LangChain)"
    ]
  },
  {
    category: "Frontend",
    items: [
      "React.js",
      "MERN Stack (MongoDB, Express, React, Node.js)",
      "TypeScript",
      "Tailwind CSS",
      "Framer Motion"
    ]
  },
  {
    category: "Automation & Integration",
    items: [
      "Make.com (Advanced Workflow Automation)",
      "n8n (No-code/Low-code Automation)",
      "Zapier"
    ]
  },
  {
    category: "Databases",
    items: [
      "MongoDB",
      "SQL (PostgreSQL, MySQL)",
      "Vector Databases (Qdrant, Pinecone)",
      "Redis"
    ]
  },
  {
    category: "Cloud & Infrastructure",
    items: [
      "Google Cloud Platform (GCP)",
      "Amazon Web Services (AWS)",
      "Vercel",
      "Docker",
      "GitHub Actions (CI/CD)"
    ]
  },
  {
    category: "Other Tools",
    items: [
      "EmailJS (email automation)",
      "Pandas, NumPy (data processing)",
      "BeautifulSoup, Selenium (web scraping)",
      "Figma (UI/UX design)",
      "Jupyter Notebook (prototyping)",
      "Postman (API testing)",
      "Git & GitHub (version control)"
    ]
  }
];

const TechStack = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section id="tech-stack" className="py-20 bg-gradient-to-br from-white via-gray-50 to-blue-50 dark:from-gray-900 dark:via-gray-900 dark:to-gray-800">
      <div className="container mx-auto px-4">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold mb-4 text-dark">Tech Stack</h2>
          <p className="text-xl text-gray-600">Tools and Technologies</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {technologies.map((tech, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white/80 dark:bg-gray-800/80 backdrop-blur p-6 rounded-2xl shadow-lg border border-gray-100/60 dark:border-gray-700/40 neo-surface"
            >
              <h3 className="text-xl font-semibold mb-4 text-dark dark:text-white">{tech.category}</h3>
              <div className="flex flex-wrap gap-2">
                {tech.items.map((item, itemIndex) => (
                  <span
                    key={itemIndex}
                    className="px-3 py-1 rounded-full text-sm bg-gradient-to-r from-blue-50 to-purple-50 dark:from-gray-700 dark:to-gray-700 text-gray-700 dark:text-gray-200 border border-gray-200/60 dark:border-gray-600/40 hover:shadow transition-transform hover:-translate-y-0.5"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStack; 